import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import Demographics from '../../../../../../Household/LandingPage/Demographics';

const styles = theme => ({
  container: {}, // Not used -- just to get around a console error
  root: {
    paddingTop: theme.spacing(2),
    flexWrap: 'wrap',
    height: 'auto',
  },
});

const View = ({
  className,
  classes,
}) => {
  return (
    <Demographics
      className={classNames(classes.root, className)}
    />
  );
};

View.defaultProps = {
  className: '',
};

View.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(View);
